"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributes = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../model");
/**
 * @internal
 */
function useAttributes(displayForms) {
    var _a = model_1.useDashboardQueryProcessing({
        queryCreator: model_1.queryAttributeByDisplayForm,
    }), getAttributes = _a.run, attributes = _a.result, attributesLoadingStatus = _a.status, attributesLoadingError = _a.error;
    react_1.useEffect(function () {
        getAttributes(displayForms);
    }, [displayForms, getAttributes]);
    var attributesLoading = react_1.useMemo(function () {
        return attributesLoadingStatus === "pending" || attributesLoadingStatus === "running";
    }, [attributesLoadingStatus]);
    return {
        attributes: attributes,
        attributesLoading: attributesLoading,
        attributesLoadingError: attributesLoadingError,
    };
}
exports.useAttributes = useAttributes;
//# sourceMappingURL=useAttributes.js.map